// extracted by mini-css-extract-plugin
export default {"titleName":"TitleLogo_titleName__UpJyc","logo":"TitleLogo_logo__eZZ+V","containerTitleLogo":"TitleLogo_containerTitleLogo__rhY3e"};